import { createModalsFactory } from 'ui';

type MerchantDetailModalIds = 'Detail' | 'Terms';
type MerchantType = 'online' | 'instore' | 'dining';

type MerchantDetailModalMeta = {
  merchantId?: string;
  locationId?: string;
  type?: MerchantType;
  onCtaClick?: () => void;
};

const {
  Provider: MerchantDetailModalProvider,
  useProvider: useMerchantDetailModalProvider,
  ModalTitleWithBackButton: MerchantDetailModalTitle,
} = createModalsFactory<MerchantDetailModalIds[], MerchantDetailModalMeta>(['Detail', 'Terms']);

export { MerchantDetailModalProvider, MerchantDetailModalTitle, useMerchantDetailModalProvider };
export type { MerchantType };
